// Column ids — used by the column defs and by the sort payload.
export const ORDER_COLUMNS = Object.freeze({
  orderNo: 'orderNo',
  materialName: 'materialName',
  facilityName: 'facilityName',
  terminal: 'terminal',
  status: 'status',
  soldTo: 'soldTo',
  shippingTo: 'shippingTo',
  allocatedGhgSavings: 'allocatedGhgSavings',
  unitType: 'unitType',
  contractedQuantity: 'contractedQuantity',
  shippedQuantity: 'shippedQuantity',
  remainingToShipQuantity: 'remainingToShipQuantity',
  allocatedQuantity: 'allocatedQuantity',
  remainingToAllocateQuantity: 'remainingToAllocateQuantity',
  tolerance: 'tolerance',
  maxGhgEmissions: 'maxGhgEmissions',
  minGhgSavings: 'minGhgSavings',
  rawMaterialType: 'rawMaterialType',
  countryOfOrigin: 'countryOfOrigin',
  feedstockCategory: 'feedstockCategory',
  allocationPreference: 'allocationPreference',
  dispatchBy: 'dispatchBy',
  discrepancies: 'discrepancies',
});

// Column id → PendingOrderOrderByField; a column absent here renders unsortable.
// TODO: tolerance / ghg / raw material / country / feedstock need PendingOrderOrderByField members.
export const ORDER_SORT_FIELDS = Object.freeze({
  [ORDER_COLUMNS.orderNo]: 'orderNo',
  [ORDER_COLUMNS.materialName]: 'material',
  [ORDER_COLUMNS.contractedQuantity]: 'contractedQuantity',
  [ORDER_COLUMNS.dispatchBy]: 'dispatchDate',
});
